import * as React from 'react';
import { ActionLink, ArticleHeading4, ArticleParagraph1, ModalWindow, UIText3 } from '@cian/ui-kit';

import { IconActionArrowUpRight16 } from '@cian/ui-kit-design-tokens/icons';
import * as styles from './PromoCategoryModal.css';
import { IFactoid, IFullDescriptionItem } from '../../types/seoData';

interface IPromoCategoryModalProps {
  factoids: IFactoid[];
  fullDescription: IFullDescriptionItem[];
  isOpen: boolean;
  onClose: () => void;
  title: string;
  articleUrl?: string | null;
}

export const PromoCategoryModal: React.FC<IPromoCategoryModalProps> = ({
  factoids,
  fullDescription,
  isOpen,
  onClose,
  title,
  articleUrl,
}) => {
  return (
    <ModalWindow
      open={isOpen}
      onClose={onClose}
      title={title}
      maxWidth={848}
      content={
        <div className={styles['content']}>
          <ul className={styles['factoid-list']}>
            {factoids.map(({ title, value }, index) => (
              <li key={index} className={styles['factoid']}>
                <div className={styles['factoid-title-wrapper']}>
                  <UIText3 color="current_color">{title}</UIText3>
                </div>
                <ArticleParagraph1>{value}</ArticleParagraph1>
              </li>
            ))}
          </ul>
          {fullDescription.map(({ title, items }, index) => (
            <div key={index}>
              <ArticleHeading4>{title}</ArticleHeading4>
              <ul className={styles['text-list']}>
                {items.map((item, subIndex) => (
                  <li key={subIndex}>
                    <ArticleParagraph1 whiteSpace="pre-line">{item}</ArticleParagraph1>
                  </li>
                ))}
              </ul>
            </div>
          ))}
          {articleUrl && (
            <a href={articleUrl} target="_blank" rel="noreferrer">
              <ActionLink fontSize="M" afterIcon={<IconActionArrowUpRight16 color="icon-main-default" />}>
                Изучить подробнее
              </ActionLink>
            </a>
          )}
        </div>
      }
    />
  );
};
